<template>
  <a-select
    ref="TreeSelect"
    v-model:value="selectedValue"
    placeholder="请选择"
    @change="changeValue"
    showSearch
    @search="searchValue"
  >
    <template #dropdownRender="{ menuNode: menu }">
      <a-tree
        v-if="treeData.length > 0"
        class="m-tree"
        :fieldNames="{ title: 'name', key: 'id', value: 'id' }"
        :tree-data="treeData"
        v-model:selectedKeys="selectedTreeKeys"
        v-model:expandedKeys="expandedKeys"
        :blockNode="true"
      >
        <!-- @select="selectTreeData" -->

        <template #title="{ name, id }">
          <div @click="selectTreeData(id, name)">
            <span v-if="name.indexOf(searchValueKey) > -1 && searchValueKey != ''">
              {{ name.substr(0, name.indexOf(searchValueKey)) }}
              <span style="color: #f59a23">{{ searchValueKey }}</span>
              {{ name.substr(name.indexOf(searchValueKey) + searchValueKey.length) }}
            </span>
            <span v-else>{{ name }}</span>
          </div>
        </template>
      </a-tree>
      <div v-else style="padding: 0 10px">没有查询结果</div>
      <a-divider style="margin: 4px 0" />
      <div
        class="select-add"
        style="padding: 4px 8px; cursor: pointer"
        @mousedown="(e) => e.preventDefault()"
        @click="addItem"
      >
        <plus-outlined />
        新建分类
        <span style="color: #317efd" v-if="treeData.length == 0"> "{{ searchValueKey }}" </span>
      </div>
    </template>
  </a-select>
</template>

<script lang="ts" setup>
import { CategoryService } from "@/views/material/category/category.service";
import { onMounted, ref, unref } from "vue";
import { PlusOutlined } from "@ant-design/icons-vue";
import ArrayToTree from "array-to-tree";
import { hmdConfirm } from "@/dialog/index";

const props = withDefaults(
  defineProps<{
    value?: string;
  }>(),
  {
    value: "",
  }
);

const emits = defineEmits(["change", "update:value"]);
const TreeSelect = ref<HTMLElement | null>(null);
const selectedValue = ref<string | undefined>("");
const searchValueKey = ref("");

const selectedTreeKeys = ref<Array<string>>([]);
const expandedKeys = ref<Array<string>>([]);

const treeData = ref([]);
const treeArrData = ref([]);
const addItem = () => {
  let v = searchValueKey.value;
  hmdConfirm({
    com: import("@/views/material/category/list/category-form-btn/index.vue"),
    params: {
      categoryName: searchValueKey.value,
    },
    zIndex: 1200,
    confirm: async ({ params, res }) => {
      // console.log("🚀 ~ file: index.vue ~ line 80 ~ confirm: ~ params, res", params, res);
      await run();
      treeData.value = (unref(data) as any)?.treeRecords;
      treeArrData.value = (unref(data) as any)?.records;
      // console.log(treeData, "----------", data, res);
      selectedValue.value = res;
      selectedTreeKeys.value = [findObjByName(res)?.id];
      expandedKeys.value = getParentArr(findObjByName(res)?.id);
      // // console.log(
      //   "🚀 ~ file: index.vue ~ line 86 ~ confirm: ~ selectedValue",
      //   selectedValue,
      //   selectedTreeKeys,
      //   expandedKeys,
      //   v
      // );
      emits("update:value", findObjByName(res)?.id);
      emits("change", findObjByName(res)?.id);
    },
    close: () => {},
  });
};
const { data, run, loading } = CategoryService.useSimpleListApi();
const selectTreeData = (id, name) => {
  //   // console.log("🚀 ~ file: index.vue ~ line 45 ~ selectTreeData ~ e", e);
  selectedValue.value = name;
  if (TreeSelect.value) {
    TreeSelect.value.blur?.();
  }
  emits("update:value", id);
  emits("change", id);
};
const changeValue = () => {};
const searchValue = (v, option) => {
  // console.log("🚀 ~ file: index.vue ~ line 65 ~ v,option", v, option);
  const res: any = [];
  searchValueKey.value = v;

  if (v == "") {
    treeData.value = (unref(data) as any)?.treeRecords;
    return;
  }

  treeArrData.value.map((o: any) => {
    if (o.name.indexOf(v) > -1) {
      res.push(o);
    }
  });
  treeData.value = ArrayToTree(res || [], {
    parentProperty: "parentId",
    customID: "id",
  });
};
const findObjById: any = (id) => {
  return treeArrData.value.find((o: any) => o.id === id);
};
const findObjByName: any = (name) => {
  return treeArrData.value.find((o: any) => o.name === name);
};
const getParentArr = (id) => {
  let r: any = treeArrData.value.find((o: any) => o.id === id);
  let result = [id];
  if (!r) {
    return [];
  }
  while (r["parentId"] && r["parentId"] != "0") {
    r = treeArrData.value.find((o: any) => o.id === r["parentId"]);
    result.push(r.id);
  }

  return result;
};
onMounted(async () => {
  await run();
  treeData.value = (unref(data) as any)?.treeRecords;
  treeArrData.value = (unref(data) as any)?.records;
  // console.log(treeData, "----------", data);

  selectedValue.value = findObjById(props.value)?.name;
  selectedTreeKeys.value = [props.value];
  expandedKeys.value = getParentArr(props.value);
  // // console.log(
  //   "🚀 ~ file: index.vue ~ line 96 ~ onMounted ~ selectedTreeKeys.value",
  //   selectedTreeKeys.value,
  //   selectedValue
  // );
});
</script>
<style lang="less" scoped>
/deep/.m-tree {
  max-height: 280px;
  overflow-y: auto;
}
.select-add {
  color: #505050;
}
</style>
